import React, { useEffect, useState } from "react";
import Select from "../../../../Components/Select";
import Input from "../../../../Components/Input";
import DateInput from "../../../../Components/DateInput";

import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../../Redux";
import { getFormData } from "../../../../../helpers";
import UserInterface from "../../../../Components/InnerLayout/UserInterface";
import Headerbar from "../../../../Components/InnerLayout/Headerbar";
import { useHistory } from "react-router-dom";

const AddSales = (props) => {
  const history = useHistory();
  const historyStateObj = props.location.state;
  const [type, setType] = useState(historyStateObj?.type || "add");
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions?.getOtherIncomeDataOptions());
    // setType(props.location.state);
  }, []);

  const formOptions = useSelector(
    (state) => state?.financeReducer?.otherIncomeData
  );
  const editData = useSelector((state) =>
    state?.financeReducer?.salesData?.other_income?.find(
      (el) => el.id == historyStateObj?.id
    )
  );
  const [transactionDate, setTransactionDate] = useState(
    editData?.transaction_date || null
  );

  const defaultState = {
    merchant_id: editData?.merchant_id.toString() ?? "",
    income_group_id: editData?.income_group_id ?? "",
    transaction_amount: editData?.transaction_amount ?? "",
    sales_tax_in_income_amount: editData?.sales_tax_in_income_amount ?? "",
    transaction_date: editData?.transaction_date ?? "",
    invoice_id: editData?.invoice_id ?? "",
    description: editData?.description ?? "",
    income_account_id: editData?.income_account_id ?? "",
    receiving_account_id: editData?.receiving_account_id ?? "",
    attachment: editData?.attachment ?? "",
  };

  useEffect(() => {
    reset(defaultState);
  }, [formOptions]);

  const schema = yup.object().shape({
    merchant_id: yup.string().required(),
    income_group_id: yup.string().required(),
    transaction_amount: yup.string().required(),
    sales_tax_in_income_amount: yup.string().required(),
    transaction_date: yup.string().required(),
    invoice_id: yup.string().required(),
    description: yup.string().required(),
    income_account_id: yup.string().required(),
    receiving_account_id: yup.string().required(),
    attachment: yup.mixed().required(),
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
    getValues,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: defaultState,
  });

  function submitData(data) {
    const submitData = {
      hisotry: history,
      merchant_id: data?.merchant_id,
      data: getFormData({
        ...data,
        attachment: data.attachment[0],
      }),
    };
    if (type === "add") dispatch(actions?.postOtherIncomeData(submitData));
    else {
      const submitData = {
        history: history,
        id: historyStateObj?.id,
        data: getFormData({
          attachment: data.attachment[0],
          transaction_amount: data?.transaction_amount,
          sales_tax_in_income_amount: data?.sales_tax_in_income_amount,
          transaction_date: data?.transaction_date,
          merchant_id: data?.merchant_id,
        }),
      };
      dispatch(actions?.postOtherIncomeEditData(submitData));
    }
  }

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="shadowclass">
              <div className="d-flex justify-content-between mb-3 align-items-center p-2">
                <h4 class="event-alert p-0 m-0">Add Other Income</h4>
              </div>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                }}
                className="row mx-0 px-0 justify-content-between align-items-center"
              >
                <ul className="ingredient-info edit-shift">
                  <p>merchant:{getValues(["merchant_id"])}</p>
                  <Select
                    label={"Account ID"}
                    formError={errors}
                    formKey="merchant_id"
                    formRegister={register}
                    optionsArray={formOptions?.merchant_list}
                  />
                  <Select
                    label={"Income Group"}
                    formRegister={register}
                    formError={errors}
                    formKey="income_group_id"
                    optionsArray={formOptions?.income_group}
                  />

                  <Input
                    label={"Transaction Amount"}
                    formRegister={register}
                    formError={errors}
                    formKey="transaction_amount"
                  />

                  <Select
                    label={"Sales tax included in income amount?"}
                    formRegister={register}
                    formError={errors}
                    formKey="sales_tax_in_income_amount"
                    optionsArray={[
                      { value: "yes", label: "Yes" },
                      { value: "no", label: "No" },
                    ]}
                  />
                  <li className={""}>
                    <label className={""}>Transaction ID</label>
                    <div class={`input-group`}>
                      <p>{formOptions?.transaction_id}</p>
                    </div>
                  </li>
                  <DateInput
                    label={"Transaction Date"}
                    formRegister={register}
                    formError={errors}
                    formKey="transaction_date"
                    setFormField={setValue}
                    dateVal={transactionDate}
                    horizontal={true}
                    setDateVal={setTransactionDate}
                  />
                  <Input
                    label={"Invoice ID"}
                    formRegister={register}
                    formError={errors}
                    formKey="invoice_id"
                  />
                  <Input
                    label={"Description"}
                    formRegister={register}
                    formError={errors}
                    formKey="description"
                  />
                  <Select
                    label={"Income Amount"}
                    formRegister={register}
                    formError={errors}
                    formKey="income_account_id"
                    optionsArray={formOptions?.other_income_accounts}
                  />
                  <Select
                    label={"Receiving Amount"}
                    formRegister={register}
                    formError={errors}
                    formKey="receiving_account_id"
                    optionsArray={formOptions?.total_receiving_accounts}
                  />
                  <Input
                    label={"Attachment 1"}
                    formRegister={register}
                    formError={errors}
                    formKey="attachment"
                    isModal
                    type="file"
                  />
                </ul>
                <div className="clearfix"> &nbsp; </div>
                <div class="btns d-flex justify-content-end">
                  <button
                    onClick={() => history.goBack()}
                    class="btn"
                    name="submit"
                    type="submit"
                    id="cancel"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleSubmit(submitData)}
                    class="btn"
                    name="submit"
                    type="submit"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};

export default AddSales;
